import { PwdRule } from './PwdRule';

export class PwdRulesState {
  pwdLengthRule: PwdRule;
  pwdUpperLowerCaseRule: PwdRule;
  pwdAtLeastOneDigit: PwdRule;
  pwdAtLeastOneSpecSym: PwdRule;
  pwdLatinRule: PwdRule;
  pwdMatchRule: PwdRule;
  pwdStrengthRule: PwdRule;

  constructor(isCorrect: boolean = false) {
    this.pwdLengthRule = new PwdRule(isCorrect);
    this.pwdUpperLowerCaseRule = new PwdRule(isCorrect);
    this.pwdAtLeastOneDigit = new PwdRule(isCorrect);
    this.pwdAtLeastOneSpecSym = new PwdRule(isCorrect);
    this.pwdLatinRule = new PwdRule(isCorrect);
    this.pwdMatchRule = new PwdRule(isCorrect);
    this.pwdStrengthRule = new PwdRule(isCorrect);
  }
}
